module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"recommended_series":"Popular Series","view_more":"All Series"},"ja":{"recommended_series":"人気シリーズ","view_more":"シリーズ一覧"}}')
  delete Component.options._Ctor
}
